<template>
  <v-form class='companyProfileForm' v-model='valid' ref='companyProfileForm'>
    <v-container class='mb-10'>
      <v-row>
        <v-col cols='12' md='2' sm='6' xs='12'>
          <div class="logo_box text-center">
            <input type="file" class="d-none" ref="file_input_company_profile" @change="fileChangeEvent" @click="resetImageUploader">
            <div v-for="(image, i) in images" :key="i">
              <v-img
              :src="`${image.url}`"
              ></v-img>
            </div>
          </div>
          <v-btn color="primary" small class="ma-1" @click="uploadImage">Change</v-btn>
        </v-col>
        <v-col cols='12' md='2' sm='6' xs='12'>
          <v-text-field
          v-model='companyProfile.name'
          :error-messages='error.name'
          label='Name'
          placeholder='Name'
          autofocus
          ref="firstInput"
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='2' sm='6' xs='12'>
          <v-text-field
          v-model='companyProfile.gst'
          :error-messages='error.gst'
          label='Gst'
          placeholder='Gst'
          ></v-text-field>
        </v-col>
        <v-col cols='12' md='4' sm='6' xs='12'>
          <v-textarea
          v-model="companyProfile.address"
          label="Address"
          placeholder="Address"
          rows="2"
          ></v-textarea>
        </v-col>
        <v-col cols='12' md='2' sm='6' xs='12'>
          <v-text-field
          v-model='companyProfile.sampling_rate'
          :error-messages='error.sampling_rate'
          label='Sampling Rate'
          placeholder='Sampling Rate'
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-footer fixed>
      <v-col class="text-right">
        <v-btn color="primary" class="mr-2" @click="submit" small>Save</v-btn>
      </v-col>
    </v-footer>
  </v-form>
</template>

<script>
export default {
  watch: {
    $route: function () {
      this.edit_id = this.$route.params.id
      this.reset()
    }
  },
  mounted () {
    this.companyProfile = this.$getCompanyData()
    const id = this.companyProfile.id
    if (id) {
      this.$axios.post('getCompanyById/' + id).then((res) => {
        this.companyProfile = res.data.data
        this.images = { 0: { url: this.companyProfile.url } }
      }).catch(() => {
        this.loading = false
        console.log('some error occurred')
      })
    }
  },
  data () {
    return {
      valid: false,
      edit_id: undefined,
      companyProfile: { status: 0 },
      error: {},
      images: [],
    }
  },
  methods: {
    submit () {
      if (Object.keys(this.error).length > 0) {
        this.error = {}
        this.valid = true
      }
      if (this.valid) {
        const route = 'saveCompany/' + this.companyProfile.id
        this.$axios.post(route, this.companyProfile).then((res) => {
          this.$eventBus.$emit('$globalSnackbar', 'success', res.data.success_description)
        }).catch((err) => {
          if (err.response.status === 422) {
            this.error = err.response.data.error_data
          } else {
            this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
          }
        })
      } else {
        this.$refs.companyProfileForm.validate()
      }
    },
    uploadImage () {
      this.$refs.file_input_company_profile.click()
    },
    resetImageUploader () {
      this.$refs.file_input_company_profile.value = ''
      this.images = []
    },
    fileChangeEvent () {
      if (this.$refs.file_input_company_profile.files.length) {
        const formData = new FormData()
        formData.append('access_token', localStorage.getItem(process.env.VUE_APP_LSACCESSTOKENKEY))
        formData.append('request_from', 'clientApp')
        const file = this.$refs.file_input_company_profile.files[0]
        formData.append('files[0]', file)
        this.$axios.post('upload', formData, { removeCommonParams: true, requestForSearchable: true }).then((res) => {
          this.images = [...this.images, ...res.data.files]
          this.companyProfile.logo = this.images[0]
        }).catch((err) => {
          console.log(err.response)
        })
      }
    },
  },
}
</script>
<style>
.logo_box {
  border: 1px dotted #ccc;
  min-height: 80px;
  width: 100%;
}
</style>
